




















import Vue from 'vue'
import './TextInput.scss'

export default Vue.extend({
  name: 'TextInput',
  props: {
    submitColor: {
      type: String,
      required: true
    },
    submitTextColor: {
      type: String,
      required: true
    }
  },
  data: () => ({
    textValue: ''
  }),
  methods: {
    sendMessage () {
      if (this.textValue !== '') {
        this.$emit('sendMessage', this.textValue)
        this.textValue = ''
      }
    }
  }
})
